import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BookMark, BookmarkData } from 'src/app/models/Bookmark';
import { SettingsService } from 'src/app/pages/settings/settings.service';
import { TaskData } from 'src/app/pages/stock/stock.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ShareDataService } from 'src/app/services/share-data.service';

@Component({
    selector: 'app-bookmark',
    templateUrl: './bookmark.component.html',
    styleUrls: ['./bookmark.component.scss'],
    standalone: false
})
export class BookmarkComponent implements OnInit {

  constructor(private shareDataService: ShareDataService
    , private settingsService: SettingsService
    , private notificationService: NotificationService) { }

  popupSaveBookmarkVisible: boolean = false;
  popuploadBookmarkVisible: boolean = false;
  bookmarkName: string = "";
  isDefault: boolean = false;
  bookmarks: any;

  @Input() PageName = '';
  @Output() loadDataEvent = new EventEmitter<any>();

  ngOnInit() {

  }

  loadGrid() {

    this.settingsService.LoadBookmark(this.PageName).subscribe(data => {
      this.bookmarks = data;

    }, err => {
      this.notificationService.error(err);

    });
  }

  taskNewFilter: TaskData;
  taskFilter: TaskData[] = [];
  dataBookmark: BookMark;

  OpenBookmarkSaveOption(action: string) {
    if (action == 'open') {
      this.popuploadBookmarkVisible = true;
      this.loadGrid();
    } else {
      this.popuploadBookmarkVisible = false;
    }
  }

  OpenBookmarkClick(action: string) {
    if (action == 'open') {
      this.popupSaveBookmarkVisible = true;
    } else {
      this.popupSaveBookmarkVisible = false;
    }
  }

  SaveBookmarkClick(action: string) {
    this.taskFilter = [];
    if (action == 'Cancel') {
      this.popupSaveBookmarkVisible = false;
    }
    else {
      this.dataBookmark = new BookMark();
      if (this.shareDataService.filterOptions && this.shareDataService.filterOptions.filters) {
        this.shareDataService.filterOptions.filters.forEach(itemFilter => {
          this.taskNewFilter = new TaskData();
          this.taskNewFilter.SettingValue = itemFilter.fieldValue;
          this.taskNewFilter.SettingId = itemFilter.settingId;
          this.taskNewFilter.FieldName = '';
          this.taskFilter.push(this.taskNewFilter);
        });
      }

      if (this.shareDataService.filterOptionOverview && this.shareDataService.filterOptionOverview.filters) {
        this.shareDataService.filterOptionOverview.filters.forEach(itemFilter => {
          this.taskNewFilter = new TaskData();
          this.taskNewFilter.SettingValue = itemFilter.value;
          this.taskNewFilter.FieldName = itemFilter.fieldName;
          this.taskNewFilter.SettingId = null;
          this.taskFilter.push(this.taskNewFilter);
        });
      }

      if (this.shareDataService.periodType) {
        this.taskNewFilter = new TaskData();
        this.taskNewFilter.SettingValue = this.shareDataService.periodType;
        this.taskNewFilter.FieldName = "PeriodType";
        this.taskNewFilter.SettingId = null;
        this.taskFilter.push(this.taskNewFilter);
      }

      if (this.shareDataService.capacityOverviewSelectedColumn) {
        this.taskNewFilter = new TaskData();
        this.taskNewFilter.SettingValue = this.shareDataService.capacityOverviewSelectedColumn;
        this.taskNewFilter.FieldName = "CapacityColumn";
        this.taskNewFilter.SettingId = null;
        this.taskFilter.push(this.taskNewFilter);
      }

      this.dataBookmark.pageName = this.PageName;
      this.dataBookmark.name = this.bookmarkName;
      this.dataBookmark.taskFilterData = [];
      this.dataBookmark.taskFilterData = this.taskFilter;
      this.dataBookmark.isDefault = this.isDefault;
      this.dataBookmark.chartSettings = this.shareDataService.ChartSettings;

      if (this.shareDataService.pivotSettings) {
        this.dataBookmark.pivotSettings = this.shareDataService.pivotSettings;
      }

      if(this.shareDataService.dataGridState) {
        this.dataBookmark.dataGridState = this.shareDataService.dataGridState;
      }


      console.log(this.dataBookmark);
      this.settingsService.SaveBookmark(this.dataBookmark).subscribe(data => {

        if (data != null) {
          if (data.flag > 0) {
            this.notificationService.success(data.msg);
            this.bookmarkName = "";
            this.isDefault = false;
            this.popupSaveBookmarkVisible = false;
            this.loadGrid();
          }
          else {
            this.notificationService.error(data.msg);
          }
        }
        else {
          this.notificationService.error("something went wrong. please try again later.");
        }

      }, err => {
        this.notificationService.error(err);

      });
    }

    this.popuploadBookmarkVisible = false;
  }

  ChnageDefaultValues(params) {
    if (params != null && params != undefined
      && this.bookmarks != null && this.bookmarks != undefined
      && this.bookmarks.length > 0) {
      if (params.isDefault != null && params.isDefault == true) {
        this.bookmarks.forEach(element => {
          if (element.bookmarkId != params.bookmarkId) {
            element.isDefault = false;
          }
        });
      }
    }
  }

  LoadBookmarkById(params) {
    this.loadDataEvent.emit(params.data);
    this.popuploadBookmarkVisible = false;
  }

  DeleteBookmarkById(params) {

    this.settingsService.deleteBookmark(params.data).subscribe(data => {

      if (data != null) {
        if (data.flag > 0) {
          this.notificationService.success(data.msg);
          this.loadGrid();
        }
        else {
          this.notificationService.error(data.msg);
        }
      }
      else {
        this.notificationService.error("something went wrong. please try again later.");
      }
    }, err => {
      this.notificationService.error(err);

    });
  }

  UpdateDefualtBookmarkClick(action: string) {
    if (this.bookmarks != null && this.bookmarks != undefined && this.bookmarks.length > 0)
      var bookmarksData = this.bookmarks.filter(x => x.isDefault == true);
    let dataBookmarkUpdate: BookmarkData = new BookmarkData();
    if (bookmarksData != null && bookmarksData.length > 0) {
      dataBookmarkUpdate.BookmarkId = bookmarksData[0].bookmarkId;
      dataBookmarkUpdate.isDefault = bookmarksData[0].isDefault;
      dataBookmarkUpdate.name = bookmarksData[0].name;
      dataBookmarkUpdate.pageName = bookmarksData[0].pageName;
    } else {
      dataBookmarkUpdate.BookmarkId = this.bookmarks[0].bookmarkId;
      dataBookmarkUpdate.isDefault = this.bookmarks[0].isDefault;
      dataBookmarkUpdate.name = this.bookmarks[0].name;
      dataBookmarkUpdate.pageName = this.bookmarks[0].pageName;
    }


    this.settingsService.UpdateBookmark(dataBookmarkUpdate).subscribe(data => {

      if (data != null) {
        if (data.flag > 0) {
          this.notificationService.success(data.msg);
          this.loadGrid();
        }
        else {
          this.notificationService.error(data.msg);
        }
      }
      else {
        this.notificationService.error("something went wrong. please try again later.");
      }
    }, err => {
      this.notificationService.error(err);

    });

  }

}
